import React, { Component } from 'react';
import Radium from 'radium';
import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';
import BusinessAddress from './BusinessAddress';

const LOCATION_LAT = 40.4036525;
const LOCATION_LNG = -74.2318518;
export const LOCATION_URL = 'https://www.google.com/maps/dir//1008+NJ-34,+Matawan,+NJ+07747/@' + LOCATION_LAT + ',' + LOCATION_LNG + ',21z/';

class BusinessMap extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showingInfoWindow: false,
			activeMarker: {},
			selectedPlace: {}
		};
	}

	showInfoWindow = (props, marker, e) => {
		this.setState({
			selectedPlace: props,
			activeMarker: marker,
			showingInfoWindow: true
		});
	};

	hideInfoWindow = (props) => {
		if (this.state.showingInfoWindow) {
			this.setState({
				showingInfoWindow: false,
				activeMarker: null
			})
		}
	};

	openDirectionsWindow = () => {
		window.open(LOCATION_URL, '_blank');
	};

	render() {
		return (
			<div style={this.props.style}>
				<Map google={this.props.google} initialCenter={{lat: LOCATION_LAT, lng: LOCATION_LNG}} zoom={19} style={{"width": "96%", "height": "96%", "zIndex": "990"}}>

				<Marker
					onClick={this.openDirectionsWindow}
					onMouseover={this.showInfoWindow}
					onMouseout={this.hideInfoWindow}
					title={'Ecofresh Cleaners'}
				/>

				<InfoWindow marker={this.state.activeMarker} visible={this.state.showingInfoWindow}>
					<BusinessAddress hidePhone={true} hideEmail={true}/>
				</InfoWindow>

				</Map>
			</div>
		)
	}
}

export default GoogleApiWrapper({
	apiKey: ("AIzaSyDu8gozjUde_llcKGWn1odY_78QJ4VyShE"),
	version: '3'
})(Radium(BusinessMap))


// WEBPACK FOOTER //
// ./src/components/BusinessMap.js